import { useCallback, useEffect, useState } from "react";
import type { WorkspaceSummary } from "../types";

/**
 * Workspaces da org do usuário + o ativo (multi-tenant). O workspace ativo
 * define o escopo de código consultado pelas novas conversas.
 *
 * Trocar de workspace grava a preferência no servidor (cookie) e recarrega a
 * página: é o caminho mais simples e correto, já que o escopo afeta o system
 * prompt, as conversas visíveis e o branding.
 */
export function useWorkspaces(enabled: boolean) {
  const [items, setItems] = useState<WorkspaceSummary[]>([]);
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    fetch("/api/workspaces")
      .then((r) => (r.ok ? r.json() : { items: [], activeId: null }))
      .then((j: { items: WorkspaceSummary[]; activeId: string | null }) => {
        if (!alive) return;
        setItems(j.items ?? []);
        setActiveId(j.activeId ?? null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [enabled]);

  const switchTo = useCallback(
    async (workspaceId: string) => {
      if (workspaceId === activeId) return;
      const r = await fetch("/api/workspaces/switch", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ workspaceId }),
      });
      if (r.ok) window.location.reload();
    },
    [activeId],
  );

  return { items, activeId, switchTo };
}
